import { Link } from "react-router-dom";
import type { Product } from "@/mocks/products";

export default function ProductCard({ product }: { product: Product }) {
  const onSale = typeof product.compareAt === "number" && product.compareAt > product.price;
  const pct = onSale ? Math.round((1 - product.price / (product.compareAt as number)) * 100) : 0;
  const altImg = product.wearing;

  return (
    <Link to={`/product/${product.slug}`} className="block group cursor-pointer">
      <div className={`pcard-media w-full aspect-square ${altImg ? "" : "no-alt"}`} style={{ backgroundColor: "#F4F1EC" }}>
        <img
          src={product.image}
          alt={`${product.name} — ${product.material}`}
          title={`${product.name} — ${product.material}`}
          loading="lazy"
          decoding="async"
          className="img-a"
        />
        {altImg && (
          <img
            src={altImg}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
            className="img-b"
          />
        )}
        {onSale && (
          <span
            className="absolute top-3 left-3 z-10 text-white text-[12px] leading-none px-3 py-2"
            style={{ backgroundColor: "#BD4C2A" }}
          >
            -{pct}%
          </span>
        )}
      </div>
      <div className="mt-4">
        <h4 className="text-[15px] leading-tight text-black">
          <span className="transition-colors duration-200 group-hover:text-[#1E144D]">{product.name}</span>
        </h4>
        <p className="mt-[6px] text-[13px] text-graphite">{product.material}</p>
        {onSale ? (
          <p className="mt-[6px] text-[15px] flex items-baseline gap-2">
            <span style={{ color: "#BD4C2A" }}>${product.price.toLocaleString()}</span>
            <span className="text-[13px] text-graphite/70 line-through">${(product.compareAt as number).toLocaleString()}</span>
          </p>
        ) : (
          <p className="mt-[6px] text-[15px] text-black">${product.price.toLocaleString()}</p>
        )}
      </div>
    </Link>
  );
}